import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { Icon } from "@iconify/react";
import { FormProvider, RHFTextField } from "@app/components";
import { RenderTimeStamp } from "@app/utils";
import { RequestStatus, Strings } from "@app/constants";
import { Header } from "../types";
import { MoreVert } from "@mui/icons-material";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getrequest } from "../slice";
import { selectrequestState } from "../selector";
import { useRequestState } from "@app/hooks";

export const Requests = () => {
  const theme = useTheme();
  const methods = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [selectedRowType, setSelectedRowType] = useState<string>(""); // New state for type
  const [page, setPage] = useState<number>(1);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    dispatch(getrequest({ limit: 10, page, search: "" }));
  }, [dispatch, page]);

  const { data: allRequest, status: requestStatus } = useRequestState({
    stateSelector: selectrequestState,
    errorShown: true,
  });

  console.log(allRequest, "allRequest");

  const { data: requestsArray = [] } = allRequest || {};

  useEffect(() => {
    if (requestsArray.length > 0) {
      requestsArray.forEach((request: any) => {});
    }
  }, [requestsArray]);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    id: number,
    type: string,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(id);
    setSelectedRowType(type); // Store the type when menu opens
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
    setSelectedRowType("");
  };

  const fontFamily = Strings.fontLanguage.workSans;
  console.log("requestsArray>>>", requestsArray);

  const filteredRequests = requestsArray.filter((item: any) => {
    const searchTerm = searchValue.toLowerCase();
    const carBrand =
      `${item?.car?.brand?.name} ${item?.car?.model?.name} `?.toLowerCase() ||
      "";
    return (
      item?.firstName?.toLowerCase().includes(searchTerm) ||
      carBrand.includes(searchTerm) ||
      item?.type?.toLowerCase().includes(searchTerm) ||
      item?.status?.toLowerCase().includes(searchTerm) ||
      item?.requestId?.toLowerCase().includes(searchTerm) ||
      item?.date?.toLowerCase().includes(searchTerm)
    );
  });

  return (
    <FormProvider methods={methods}>
      <Box
        sx={{
          p: 3,
          backgroundColor: "#fff",
          borderRadius: 1,
          minHeight: { xs: "auto", md: "calc(100vh - 64px)" },
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="space-between"
          mb={3}
          alignItems="center"
        >
          <RHFTextField
            size="medium"
            placeholder="Search"
            fullWidth
            name="Search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value.toLowerCase())}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon icon="mdi:magnify" fontSize={30} />
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <TableContainer sx={{ border: "1px solid #E0E0E0", borderRadius: 1 }}>
          <Table>
            <TableHead>
              <TableRow>
                {Header.map((heading) => (
                  <TableCell
                    align="center"
                    key={heading}
                    sx={{
                      fontWeight: 600,
                      fontFamily,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {requestStatus === RequestStatus.RUNNING ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Loading...
                  </TableCell>
                </TableRow>
              ) : filteredRequests.length > 0 ? (
                filteredRequests.map((item: any, index: number) => (
                  <TableRow
                    key={index}
                    hover // <--- CHANGE: Added hover effect
                    sx={{ cursor: "pointer" }} // <--- CHANGE: Added pointer cursor
                    onClick={() => {
                      // <--- CHANGE: Added onClick handler
                      // NOTE: Make sure PATH_DASHBOARD.requests is defined in your paths file
                      navigate(`${PATH_DASHBOARD.requests}/${item.id}`);
                    }}
                  >
                    <TableCell align="center">
                      {item.requestId ?? "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {item.firstName ?? "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {item.car?.brand?.name && item.car?.model?.name
                        ? `${item.car.brand.name} ${item.car.model.name}`
                        : "N/A"}
                    </TableCell>
                    <TableCell align="center">{item.type ?? "N/A"}</TableCell>
                    <TableCell align="center">
                      {RenderTimeStamp(item.date + " " + item.time)}
                    </TableCell>
                    <TableCell align="center">
                      <Box
                        sx={{
                          display: "inline-block",
                          px: 1.5,
                          py: 1,
                          borderRadius: 1,
                          fontWeight: 600,
                          fontSize: 14,
                          ...(item.status === "Pending" && {
                            backgroundColor: theme.palette.warning.lighter,
                            color: theme.palette.warning.main,
                          }),
                          ...(item.status === "Assigned" && {
                            backgroundColor: theme.palette.success.lighter,
                            color: theme.palette.success.main,
                          }),
                          ...(item.status === "Rejected" && {
                            backgroundColor: theme.palette.error.lighter,
                            color: theme.palette.error.main,
                          }),
                        }}
                      >
                        {item.status}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation(); // <--- CHANGE: IMPORTANT! Prevents row click
                          handleMenuOpen(e, item.id, item.type);
                        }}
                      >
                        <MoreVert />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No requests found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack
          direction="row"
          justifyContent="flex-end"
          mt={2}
          alignItems={"center"}
          height={"auto"}
          gap={2}
        >
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: 500 }}
          >
            {(() => {
              const total = Number(allRequest?.pagination?.total || 0);
              const page = Number(allRequest?.pagination?.page || 1);
              const limit = Number(allRequest?.pagination?.limit || 10);

              if (total === 0) return "Showing 0 to 0 of 0 Requests";

              const start = (page - 1) * limit + 1;
              const end = Math.min(page * limit, total);

              return `Showing ${start} to ${end} of ${total} Requests`;
            })()}
          </Typography>

          <Pagination
            count={allRequest?.pagination?.totalPages || 1}
            page={Number(allRequest?.pagination?.page) || 1}
            onChange={(e, value) => setPage(value)}
          />
          <TextField
            name="pagination"
            type="number"
            value={page}
            size="small"
            sx={{
              width: 60,
            }}
            onChange={(e) =>
              setPage(() => {
                const val = Number(e.target.value);
                if (val <= allRequest?.pagination?.totalPages) {
                  return val;
                } else if (val <= 0) {
                  return 1;
                }
                return 1;
              })
            }
          />
        </Stack>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {/* ✅ For BUY type */}
        {selectedRowType?.toLowerCase() === "buy" && (
          <>
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(PATH_DASHBOARD.changeStatus, {
                  state: { requestId: selectedRow },
                });
              }}
            >
              {Strings.button.changeStatus}
            </MenuItem>

            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(PATH_DASHBOARD.assignSalesPerson, {
                  state: { requestId: selectedRow },
                });
              }}
            >
              {Strings.button.salesPerson}
            </MenuItem>
          </>
        )}
        {/* ✅ For BUY type */}
        {selectedRowType?.toLowerCase() === "test drive" && (
          <>
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(PATH_DASHBOARD.changeStatus, {
                  state: { requestId: selectedRow },
                });
              }}
            >
              {Strings.button.changeStatus}
            </MenuItem>
          </>
        )}

        {/* ✅ For SELL type */}
        {selectedRowType?.toLowerCase() === "sell" && (
          <>
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(PATH_DASHBOARD.addValuation, {
                  state: { requestId: selectedRow },
                });
              }}
            >
              {Strings.button.valuation}
            </MenuItem>

            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(PATH_DASHBOARD.assignAgent, {
                  state: { requestId: selectedRow },
                });
              }}
            >
              {Strings.product.assignAgent}
            </MenuItem>
          </>
        )}
      </Menu>
    </FormProvider>
  );
};
